'use strict';

import Cookies from 'js-cookie';
import $ from 'jquery';

/**
 * This module has some random helper stuff in it
 */
const helper = {

  _bidderIdToIndex: {},
  _highestBidderIndex: 0,
  _userId: 0,

  /**
   * Capitalize string
   *
   * @param {string} str String to capitalize
   * @return {string} Capitalized string
   */
  capitalize: function (str) {
    return str.charAt(0).toUpperCase() + str.slice(1);
  },

  /**
   * - Format bidder names (Huutaja 1, Huutaja 2, You, ...)
   * - Format leader name
   *
   * @param {object} data Auction data
   * @return {object} Formatted data
   */
  formatAuctionData: function (data) {
    const self = this;

    // Format bidder names
    if (typeof data.bids === 'object') {

      //data.bids is DESC, need to reverse order to create bidder names from start
      //without modifying original array
      Object.keys(data.bids).reverse().forEach(function(index) {
        const bid = data.bids[index];

        if (typeof self._bidderIdToIndex[bid.user] === 'undefined') {
          self._bidderIdToIndex[bid.user] = ++self._highestBidderIndex;
        }

        if (self._userId == bid.user) { // eslint-disable-line eqeqeq
          bid.userName = self.capitalize(window.translations.general_self);
        } else {
          bid.userName = window.translations.bids_bidder + ' ' + self._bidderIdToIndex[bid.user];
        }
      });
    }

    // Format leader name
    if (self._userId == data.leader) { // eslint-disable-line eqeqeq
      data.leaderName = self.capitalize(window.translations.general_self);
      data.latestBidIsOwn = true;
    } else {
      data.leaderName = window.translations.bids_bidder + ' ' + self._bidderIdToIndex[data.leader];
      data.latestBidIsOwn = false;
    }

    return data;
  },

  /**
   * Get ID's of all auctions that are currently showing on the page, only uniques
   *
   * @return {array} The ID's
   */
  _getVisibleAuctionIDs: function () {
    let ids = [];

    // List view: multiple cars
    $('.auction-lift').each(function() {
      if(ids.indexOf($(this).data('auction-id')) === -1) {
        ids.push($(this).data('auction-id'));
      }
    });

    return ids;
  },

  /**
   *
   * Pass auctions data, personate and update markup of auction status labels
   * For example
   * - Show 'your bid is leading' or cars list view for user 1 and show 'your bid no longer leads' for user 2.
   * @param {object} data Auction data
   */
  updateAuctionStatusLabels: function (data) {

    if (typeof data !== 'undefined' && data !== null && typeof data.auction !== 'undefined') {

      // Create statuses, status depends on which person is viewing the list.
      let status = false;
      let statusCode = false;
      var currentUserId = (typeof Cookies.get('honk-extranet-id') !== 'undefined') ? Cookies.get('honk-extranet-id') : false;

      // If user is logged in, find out if he is leading
      const userIsLeading = (data.leader && currentUserId && data.leader === currentUserId) ? true : false;

      // Get status of auction (sold / ongoing / failed to sell / has not been active yet)
      if (
        typeof data.endTime === 'undefined' ||
        !data.endTime ||
        typeof data.startTime === 'undefined' ||
        data.startTime > Date.now()
      ) {
        statusCode = 'inactive';

        // An auction has never existed for this vehicle - no auction url.
        delete data.url;
      }
      else if (data.endTime > Date.now() && Date.now() >= data.startTime) {
        statusCode = 'ongoing';

        if (userIsLeading) {
          statusCode = 'winning';
        }
        else if (typeof data.allBidders !== 'undefined' && data.allBidders.indexOf(currentUserId) > -1) {
          statusCode = 'topped';
        }
      }
      else {
        statusCode = 'ended';

        if (userIsLeading) {
          statusCode = 'won';
        }

        if (data.owner === currentUserId) {
          // User is owner - return 'sold' or 'failed to sell' status
          // Check if there are bids or not
          if (data.bidAmount > 0) {
            statusCode = 'sold';
          }
          else {
            statusCode = 'failed_to_sell';
          }
        }
      }

      if (statusCode) {
        status = window.translations[statusCode];
      }

      //Markup on car lists
      if(typeof status !== 'undefined' && typeof statusCode !== 'undefined' && $('.auction-lift').length > 0) {
        $('[data-auction-id="' + data.auction + '"]').find('.auction-lift-status').each(function() {
          $(this).text(status);
          $(this).removeClass(); //removes all classes
          $(this).addClass('auction-lift-status auction-status-'+statusCode);
        });
      }

      //Markup on single car page
      if (typeof data.leader !== 'undefined' && $('.auction-leader').length > 0) {
        data = this.formatAuctionData(data);
        $('.auction-leader-' + data.auction)
          .text(data.leaderName)
          .toggleClass('auction-leader-is-self', data.latestBidIsOwn)
          .parent()
            .toggleClass('d-none', !data.leader);
      }

    }
  },

  getAuctionStatuses: function () {
    const self = this;
    const params = {
      'stage-language': window.lang,
      auction: self._getVisibleAuctionIDs()
    };

    $.get('/stage-ajax/getAuctionStatus', params, function(data) {
      if (typeof data === 'object' && typeof data.auctions === 'object') {
        data.auctions.forEach(function(auction){
          self.updateAuctionStatusLabels({
            auction: auction.id,
            priceNow: auction.priceNow,
            priceMonthly: auction.priceMonthly,
            endTime: auction.endTime,
            startTime: auction.startTime,
            bidAmount: auction.bidAmount,
            leader: auction.leader,
            owner: auction.owner,
            bids: auction.bids,
            allBidders: auction.allBidders,
            reservePriceReached: auction.reservePriceReached
          });
        });
      }
    });
  }
};

module.exports = helper;
